<template>
  <Layout>
    <!-- <keep-alive :max="10" :include="tabNames" :exclude="excludeTabs"> -->
    <!-- <router-view v-slot="{ Component }">
      <keep-alive :include="tabNames" :exclude="excludeTabs">
        <component :is="Component" />
      </keep-alive>
    </router-view> -->
    <keep-alive :include="tabNames" :exclude="excludeTabs">
      <router-view></router-view>
    </keep-alive>
  </Layout>
</template>

<script>
import Layout from "@/components/layout/layout.vue";
import { mapGetters, mapState, mapMutations } from "vuex";

export default {
  mounted() {
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      excludeTabs: (state) => state.tabs.excludeTabs,
    }),
    ...mapGetters({
      tabNames: "tabs/tabNames",
    }),
  },
  mounted() {
  },
  methods: {
  },
  components: {
    Layout,
  },
};
</script>
